import React, { FC, useMemo } from 'react';
import { normalizeString } from '../../shared/normalizeText';

interface SchemaProps {
    node: any;
    schemaAddons?: any;
    schemaType?: string;
}
export const Schema: FC<SchemaProps> = ({ node, schemaAddons, schemaType }) => {
    if (!node || (Array.isArray(node) && node.length <= 0)) {
        return <></>;
    }
    const customSchemaFields = useMemo(() => {
        if (!Array.isArray(node)) return null;
        return node.reduce(
            (obj, item) =>
                Object.assign(obj, {
                    [item.field_key]: item.field_value,
                }),
            {}
        );
    }, [node]);

    const schemaSelector = () => {
        if (node.type === `paragraph__custom_schema`) {
            // Removes backslashes, new line, and return characters from the schema string
            return normalizeString(
                node.field_custom_json_schema,
                [`\\\\`, `\\n`, `\\r`],
                { removeWhiteSpace: true }
            );
        }

        if (schemaType === `article`) {
            return {
                '@context': `https://schema.org`,
                '@type': `NewsArticle`,
                url: typeof window !== `undefined` ? window.location.href : ``,
                publisher: {
                    '@type': `Organization`,
                    name: `Charter Communications`,
                },
                ...schemaAddons,
                mainEntityOfPage:
                    typeof window !== `undefined` ? window.location.href : ``,
                articleBody: customSchemaFields[`articleBody`],
            };
        } else {
            if (node.some((el) => el.field_title)) {
                return {
                    '@context': `https://schema.org`,
                    '@type': `FAQPage`,
                    mainEntity: node.map((el) => {
                        return {
                            '@type': `Question`,
                            name: el.field_title,
                            acceptedAnswer: {
                                '@type': `Answer`,
                                text: `<p>${el.field_value}</p>`,
                            },
                        };
                    }),
                    license: `http://creativecommons.org/licenses/by-nc-sa/3.0/us/deed.en_US`,
                };
            } else {
                return {
                    '@context': `https://schema.org`,
                    '@type': `WebPage`,
                    ...customSchemaFields,
                    publisher: {
                        '@type': `Corporation`,
                        name: `Charter Communications`,
                    },
                    license: `http://creativecommons.org/licenses/by-nc-sa/3.0/us/deed.en_US`,
                };
            }
        }
    };

    const schema = schemaSelector();

    if (typeof schema === `object`) {
        return (
            <script type="application/ld+json">{JSON.stringify(schema)}</script>
        );
    }
    return <script type="application/ld+json">{schema}</script>;
};
